import React from 'react';
import { LegalDocumentLayout } from './common/LegalDocumentLayout';
import { LegalSection, LegalList, LegalListItem, LegalSubsection } from './common/LegalSection';

export const PrivacyPolicy: React.FC = () => {
  return (
    <LegalDocumentLayout
      title={'Polityka przetwarzania\ndanych osobowych (RODO)'}
      lastUpdated={new Date().toLocaleDateString('pl-PL')}
    >
      <LegalSection number={1} title="Administrator danych">
        <p>
          Administratorem danych osobowych jest <strong className="text-ink-on-dark">SOLID LABS PSA</strong>,
          ul. Mogilska 43, 31-545 Kraków, NIP: 6751768986, dalej zwany „Administratorem".
        </p>
        <p>
          Kontakt w sprawach ochrony danych osobowych:{' '}
          <a
            href="mailto:rodo@spotto.pl"
            className="text-brand-primary hover:text-brand-primary-hover transition-colors"
          >
            rodo@spotto.pl
          </a>
          . Kontakt ogólny:{' '}
          <a
            href="mailto:support@spotto.pl"
            className="text-brand-primary hover:text-brand-primary-hover transition-colors"
          >
            support@spotto.pl
          </a>
          .
        </p>
      </LegalSection>

      <LegalSection number={2} title="Zakres przetwarzanych danych">
        <p>Administrator przetwarza następujące dane osobowe:</p>
        <LegalList>
          <LegalListItem>imię i nazwisko,</LegalListItem>
          <LegalListItem>adres e-mail,</LegalListItem>
          <LegalListItem>numer telefonu,</LegalListItem>
          <LegalListItem>NIP (jeśli dotyczy),</LegalListItem>
          <LegalListItem>dane dotyczące dokonanych rezerwacji, płatności i historii korzystania z Platformy.</LegalListItem>
        </LegalList>
      </LegalSection>

      <LegalSection number={3} title="Cele i podstawa prawna przetwarzania">
        <p>Dane osobowe przetwarzane są w celu:</p>
        <LegalList>
          <LegalListItem>umożliwienia rejestracji konta i korzystania z Platformy (art. 6 ust. 1 lit. b RODO),</LegalListItem>
          <LegalListItem>realizacji rezerwacji usług sportowych (art. 6 ust. 1 lit. b RODO),</LegalListItem>
          <LegalListItem>obsługi reklamacji i kontaktu z Użytkownikiem (art. 6 ust. 1 lit. c i f RODO),</LegalListItem>
          <LegalListItem>marketingu bezpośredniego (na podstawie zgody, art. 6 ust. 1 lit. a RODO),</LegalListItem>
          <LegalListItem>realizacji obowiązków księgowych i podatkowych (art. 6 ust. 1 lit. c RODO).</LegalListItem>
        </LegalList>
      </LegalSection>

      <LegalSection number={4} title="Przekazywanie danych">
        <p>Dane mogą być przekazywane:</p>
        <LegalList>
          <LegalListItem>Obiektom i Trenerom, u których dokonywana jest rezerwacja,</LegalListItem>
          <LegalListItem>operatorom płatności,</LegalListItem>
          <LegalListItem>dostawcom usług IT i hostingu,</LegalListItem>
          <LegalListItem>uprawnionym organom publicznym na podstawie przepisów prawa.</LegalListItem>
        </LegalList>
      </LegalSection>

      <LegalSection number={5} title="Okres przechowywania danych">
        <p>Dane osobowe są przechowywane:</p>
        <LegalList>
          <LegalListItem>przez okres niezbędny do realizacji rezerwacji i obsługi konta,</LegalListItem>
          <LegalListItem>przez okres wymagany przepisami prawa (np. podatkowego — 5 lat),</LegalListItem>
          <LegalListItem>dane przetwarzane na podstawie zgody — do momentu jej wycofania.</LegalListItem>
        </LegalList>
      </LegalSection>

      <LegalSection number={6} title="Prawa użytkownika">
        <p>Użytkownik ma prawo do:</p>
        <LegalList>
          <LegalListItem>dostępu do danych,</LegalListItem>
          <LegalListItem>sprostowania, usunięcia lub ograniczenia przetwarzania,</LegalListItem>
          <LegalListItem>przenoszenia danych,</LegalListItem>
          <LegalListItem>sprzeciwu wobec przetwarzania,</LegalListItem>
          <LegalListItem>cofnięcia zgody w dowolnym momencie.</LegalListItem>
        </LegalList>
        <p>
          Żądania można kierować na adres e-mail:{' '}
          <a
            href="mailto:rodo@spotto.pl"
            className="text-brand-primary hover:text-brand-primary-hover transition-colors"
          >
            rodo@spotto.pl
          </a>
          .
        </p>
      </LegalSection>

      <LegalSection number={7} title="Bezpieczeństwo danych">
        <p>
          Administrator stosuje środki techniczne i organizacyjne zapewniające ochronę danych
          osobowych przed nieuprawnionym dostępem, utratą lub modyfikacją.
        </p>
      </LegalSection>

      <LegalSection number={8} title="Inspektor Ochrony Danych">
        <p>
          Jeśli Administrator powołał Inspektora Ochrony Danych, jego dane kontaktowe zostaną
          podane na stronie Serwisu.
        </p>
      </LegalSection>

      <LegalSection number={9} title="Pliki cookies">
        <p>
          Serwis wykorzystuje pliki cookies w celach statystycznych, funkcjonalnych i
          marketingowych. Użytkownik może w każdej chwili zmienić ustawienia przeglądarki w
          zakresie cookies.
        </p>
      </LegalSection>

      <LegalSection number={10} title="Zmiany polityki prywatności">
        <p>
          Administrator zastrzega sobie prawo do wprowadzania zmian w niniejszej polityce.
          Aktualna wersja dokumentu dostępna jest na stronie internetowej Serwisu.
        </p>
      </LegalSection>

      <LegalSubsection number=" ">
        <span className="text-ink-on-dark-muted italic">
          Niniejsza polityka stanowi integralną część regulaminów Platformy Spotto dostępnych
          w stopce strony.
        </span>
      </LegalSubsection>
    </LegalDocumentLayout>
  );
};
